export default __webpack_public_path__ + "static/media/order5.94d81cde.svg";